// Nachrichten der Verwaltung (Kundenwunsch 13.10.2026: nach dem Login „eine nachricht notification anzeigen … neue
// version für bessere benutzerfreundlichkeit … gerne bei uns melden an info@simasoftware.de oder telefonnummer … für
// feedback“, dazu „oben rechts noch ein benachrichtigungsicon mit messages. benachrichtigung kann per switch
// abgeschaltet werden dass sie nicht nochmal angezeigt wird beim nächsten start“).
// MESSAGES: neueste zuerst, fest im Code. Zustand je Benutzer und Browser (Kundenwunsch 13.10.2026: „speichern des nicht
// mehr öffnen status im localstore des users und browsers“) in localStorage unter 'nachrichtenGelesen:<Benutzer>' und
// 'nachrichtenStartAus:<Benutzer>' (Benutzer = Cognito-Name wie „12_mhinkel“, also je Mandant), je als JSON-Liste der IDs.
// messages.open = ID der Nachricht im Dialog (AppMessageDialog in MainLayout) oder null. Beim Start der Shell öffnet
// showOnStart(benutzer) die neueste Nachricht, die dieser Benutzer nicht abgeschaltet hat – einmal je Laden der Seite und
// Benutzer.
import Vue from 'vue';

export const MESSAGES = Object.freeze([
  Object.freeze({
    id: 'version-3',
    title: 'Neue Version 3.0',
    dateText: 'Oktober 2026',
    teaser: 'Die Verwaltung wurde für mehr Übersicht und bessere Benutzerfreundlichkeit überarbeitet.',
    // Screenshot des neuen Dashboards mit Beispieldaten (erfundener Mandant „Stadtwerke Musterstadt“; public/img)
    image: Object.freeze({
      src: 'img/nachrichten/dashboard-v3.jpg',
      width: 1200,
      height: 681,
      alt: 'Das neue Dashboard mit Kennzahlen, Einnahmen der letzten 30 Tage und Zahlungsarten (Beispieldaten)',
      caption: 'Das neue Dashboard (Beispieldaten)'
    }),
    intro: 'Willkommen in der neuen Ticketing-Verwaltung! Wir haben die Oberfläche grundlegend überarbeitet – für mehr ' +
      'Übersicht und eine bessere Benutzerfreundlichkeit:',
    points: Object.freeze([
      'Aufgeräumte Seiten mit Suche, Filtern und klaren Spalten',
      'Detailansichten zum Bearbeiten direkt neben der Tabelle',
      'Dashboard mit den wichtigsten Kennzahlen auf einen Blick',
      'Dunkles Farbschema für ruhiges Arbeiten (Mond-Symbol oben rechts)'
    ]),
    outro: 'Ihre Daten und die gewohnten Funktionen bleiben unverändert.',
    feedback: 'Ihre Meinung ist uns wichtig: Haben Sie Fragen, Wünsche oder Feedback? Melden Sie sich gerne bei uns.',
    contact: Object.freeze({ mail: 'info@simasoftware.de', phone: '+49 160 94925722', phoneHref: 'tel:+4916094925722' })
  })
]);

const KEY_READ = 'nachrichtenGelesen';
const KEY_MUTED = 'nachrichtenStartAus';

// Schlüssel des Benutzers (ohne Benutzer der allgemeine Schlüssel)
function keyOf(base, user) {
  return user ? base + ':' + user : base;
}

function readList(key) {
  try {
    const value = JSON.parse(window.localStorage.getItem(key) || '[]');
    return Array.isArray(value) ? value.filter(id => typeof id === 'string') : [];
  } catch (e) {
    return [];
  }
}

function writeList(key, list) {
  try {
    window.localStorage.setItem(key, JSON.stringify(list));
  } catch (e) {
    // privater Modus o. Ä.: Zustand gilt dann nur bis zum Neuladen
  }
}

export const messages = Vue.observable({
  user: null,
  read: [],
  muted: [],
  open: null
});

// Benutzer, für den der Start-Hinweis in diesem Laden der Seite schon kam
let startShownFor;

// Zustand des angemeldeten Benutzers laden (beim Start der Shell)
export function useUser(user) {
  messages.user = user || null;
  messages.read = readList(keyOf(KEY_READ, messages.user));
  messages.muted = readList(keyOf(KEY_MUTED, messages.user));
}

export function findMessage(id) {
  return MESSAGES.find(m => m.id === id) || null;
}

export function isRead(id) {
  return messages.read.indexOf(id) !== -1;
}

export function unreadCount() {
  return MESSAGES.filter(m => !isRead(m.id)).length;
}

export function isMuted(id) {
  return messages.muted.indexOf(id) !== -1;
}

export function markRead(id) {
  if (!isRead(id)) {
    messages.read = messages.read.concat(id);
    writeList(keyOf(KEY_READ, messages.user), messages.read);
  }
}

export function setMuted(id, muted) {
  const list = messages.muted.filter(x => x !== id);
  messages.muted = muted ? list.concat(id) : list;
  writeList(keyOf(KEY_MUTED, messages.user), messages.muted);
}

export function openMessage(id) {
  if (findMessage(id)) {
    messages.open = id;
    markRead(id);
  }
}

export function closeMessage() {
  messages.open = null;
}

// beim Start der Shell (MainLayout): Zustand des Benutzers laden und dessen neueste nicht abgeschaltete Nachricht
// öffnen, einmal je Laden der Seite und Benutzer
export function showOnStart(user) {
  useUser(user);
  if (startShownFor === messages.user) {
    return;
  }
  startShownFor = messages.user;
  const first = MESSAGES.find(m => !isMuted(m.id));
  if (first) {
    openMessage(first.id);
  }
}
